<div class="temp-nav-icon dropdown nav-item">
  @if (user) {
    <span class="username dropdown-toggle nav-link" role="button" data-toggle="dropdown" aria-expanded="false">
      <mat-icon>person</mat-icon>
      <span class="ml-2">{{ user.name }}</span>
    </span>
  }
  <div class="dropdown-menu">
    @if (isOwner()) {
      <a [routerLink]="['/profil']"
        class="dropdown-item py-xxs"
        (click)="trackingEvent('NAVIGATION.PREFERENCES.MYPROFILE.LINK')">
        <span>{{ 'NAVIGATION.PREFERENCES.MYPROFILE.LINK' | translate }}</span>
      </a>
    }
    @if (isOwner()) {
      <a [routerLink]="['/apothekenstammdaten']"
        class="dropdown-item py-xxs"
        (click)="trackingEvent('NAVIGATION.PREFERENCES.PHARMACY-DATA.LINK')">
        <span>{{ 'NAVIGATION.PREFERENCES.PHARMACY-DATA.LINK' | translate }}</span>
      </a>
    }
    <a [routerLink]="['/fragenundantworten']"
      routerLinkActive="navLinkActive"
      [routerLinkActiveOptions]="{exact:true}"
      class="dropdown-item py-xxs"
      (click)="trackingEvent('Hilfecenter')">
      Hilfecenter
    </a>
    <a (click)="logout()"
      data-cy="quick-nav-logout"
      class="px-m">
      <button class="btn btn-secondary my-2 btn-small d-inline-flex">
        <mat-icon class="mr-1">lock_open</mat-icon> Logout
      </button>
    </a>
  </div>
</div>

